import { RefillsPage } from './features/refills/RefillsPage';

export interface AppProps {
  userId: string | null;
  config: {
    customerServicePhone: string;
    customerServiceEmail: string;
  };
  navigate: {
    toMyAccount: (tab?: 'address' | 'creditcard') => void;
    toFeatures: () => void;
  };
}

export function App(props: AppProps) {
  return <RefillsPage {...props} />;
}
